// AUTO-GENERATED by generator.ts — DO NOT EDIT BY HAND.
// Source: contracts/entitlements/src/feature-gating-source.yaml
// Regenerate: pnpm --filter @charitystack/entitlements generate
//
// Status: active
//   Lifecycle metadata for this versioned contract (BACKEND_MONOREPO_ARCHITECTURE.md
//   Commitment 12 · Principle 2), mirrored from feature-gating-source.yaml meta.status.
//   Values: active | deprecated | superseded-by <id>.
//
// Upward-closure validated: every feature that is ON at tier T is ON at all tiers above T.
// Roadmap features are excluded — only `included` (✅) entries appear as true here.

import type { Catalog } from './types.js';

export const CATALOG: Catalog = {
  features: {
  fundraiser_form: { starter: true, base: true, plus: true, pro: true, enterprise: true },
  event_form: { starter: true, base: true, plus: true, pro: true, enterprise: true },
  hosted_pages: { starter: true, base: true, plus: true, pro: true, enterprise: true },
  donor_portal: { starter: true, base: true, plus: true, pro: true, enterprise: true },
  virtual_terminal: { starter: true, base: true, plus: true, pro: true, enterprise: true },
  subscriptions: { starter: true, base: true, plus: true, pro: true, enterprise: true },
  checkout_bump: { starter: true, base: true, plus: true, pro: true, enterprise: true },
  fee_coverage: { starter: true, base: true, plus: true, pro: true, enterprise: true },
  monthly_bump_upsell: { starter: true, base: true, plus: true, pro: true, enterprise: true },
  scheduled_donations: { starter: true, base: true, plus: true, pro: true, enterprise: true },
  multifund_promo_dedications_custom_inputs: { starter: true, base: true, plus: true, pro: true, enterprise: true },
  refunds_disputes_payouts: { starter: true, base: true, plus: true, pro: true, enterprise: true },
  mobile_app_tap_to_pay: { starter: false, base: false, plus: false, pro: false, enterprise: false },
  peer_to_peer_team_fundraising: { starter: false, base: false, plus: false, pro: false, enterprise: false },
  membership_management: { starter: false, base: false, plus: false, pro: false, enterprise: false },
  basic_donate_button_form_embed: { starter: true, base: true, plus: true, pro: true, enterprise: true },
  fundraising_bar: { starter: false, base: true, plus: true, pro: true, enterprise: true },
  qr_codes: { starter: false, base: true, plus: true, pro: true, enterprise: true },
  supporter_lists: { starter: false, base: true, plus: true, pro: true, enterprise: true },
  fundraising_flag: { starter: false, base: true, plus: true, pro: true, enterprise: true },
  add_to_cart: { starter: false, base: true, plus: true, pro: true, enterprise: true },
  overlay_popup: { starter: false, base: true, plus: true, pro: true, enterprise: true },
  prefilled_links: { starter: false, base: true, plus: true, pro: true, enterprise: true },
  contact_portal_element: { starter: false, base: true, plus: true, pro: true, enterprise: true },
  contacts_import_export_tags: { starter: true, base: true, plus: true, pro: true, enterprise: true },
  contact_merging: { starter: false, base: true, plus: true, pro: true, enterprise: true },
  notes_constituent_timeline: { starter: false, base: false, plus: false, pro: false, enterprise: false },
  lifecycle_stages_engagement_scoring: { starter: false, base: false, plus: false, pro: false, enterprise: false },
  household_linking_moves_management: { starter: false, base: false, plus: false, pro: false, enterprise: false },
  email_builder: { starter: false, base: true, plus: true, pro: true, enterprise: true },
  broadcasts_email: { starter: false, base: true, plus: true, pro: true, enterprise: true },
  broadcasts_sms: { starter: false, base: true, plus: true, pro: true, enterprise: true },
  segments: { starter: false, base: true, plus: true, pro: true, enterprise: true },
  email_templates: { starter: false, base: true, plus: true, pro: true, enterprise: true },
  marketing_automation_journeys: { starter: false, base: true, plus: true, pro: true, enterprise: true },
  custom_email_domain: { starter: false, base: true, plus: true, pro: true, enterprise: true },
  ai_content_generation: { starter: false, base: false, plus: false, pro: false, enterprise: false },
  social_media_scheduling: { starter: false, base: false, plus: false, pro: false, enterprise: false },
  text_to_give_two_way_sms: { starter: false, base: false, plus: false, pro: false, enterprise: false },
  direct_mail_acknowledgement_letters: { starter: false, base: false, plus: false, pro: false, enterprise: false },
  analytics_dashboard_ai_assistant: { starter: true, base: true, plus: true, pro: true, enterprise: true },
  post_donation_conversion_tracking: { starter: true, base: true, plus: true, pro: true, enterprise: true },
  donation_impact_aggregate: { starter: false, base: false, plus: false, pro: false, enterprise: false },
  donation_impact_campaign_breakdown: { starter: false, base: false, plus: false, pro: false, enterprise: false },
  smart_ask: { starter: false, base: false, plus: false, pro: false, enterprise: false },
  automatic_segmentation_rfm: { starter: false, base: false, plus: false, pro: false, enterprise: false },
  custom_reporting: { starter: false, base: false, plus: false, pro: false, enterprise: false },
  wealth_screening_prospecting: { starter: false, base: false, plus: false, pro: false, enterprise: false },
  public_api_webhooks_zapier: { starter: true, base: true, plus: true, pro: true, enterprise: true },
  double_the_donation: { starter: true, base: true, plus: true, pro: true, enterprise: true },
  crm_integrations: { starter: false, base: false, plus: true, pro: true, enterprise: true },
  accounting_integrations: { starter: false, base: false, plus: false, pro: false, enterprise: false },
  rbac: { starter: true, base: true, plus: true, pro: true, enterprise: true },
  per_donation_tax_receipts: { starter: true, base: true, plus: true, pro: true, enterprise: true },
  eoy_bulk_tax_receipts: { starter: false, base: true, plus: true, pro: true, enterprise: true },
  support_docs: { starter: true, base: true, plus: true, pro: true, enterprise: true },
  email_support: { starter: false, base: true, plus: true, pro: true, enterprise: true },
  chat_support: { starter: false, base: false, plus: true, pro: true, enterprise: true },
  dedicated_csm_sla: { starter: false, base: false, plus: false, pro: false, enterprise: true },
  },
  limits: {
  contacts: { starter: 'unlimited', base: 'unlimited', plus: 'unlimited', pro: 'unlimited', enterprise: 'unlimited' },
  broadcasts_concurrent: { starter: 0, base: 4, plus: 'unlimited', pro: 'unlimited', enterprise: 'unlimited' },
  segments_concurrent: { starter: 0, base: 'unlimited', plus: 'unlimited', pro: 'unlimited', enterprise: 'unlimited' },
  sms_included_per_month: { starter: 0, base: 250, plus: 1500, pro: 5000, enterprise: null },
  email_templates: { starter: null, base: 'unlimited', plus: 'unlimited', pro: 'unlimited', enterprise: 'unlimited' },
  seats: { starter: 'unlimited', base: 'unlimited', plus: 'unlimited', pro: 'unlimited', enterprise: 'unlimited' },
  },
  fees: {
    platformFeeCovered: {
      starter: '0.0700', base: '0.0600', plus: '0.0500', pro: '0.0400', enterprise: 'custom',
    },
    platformFeeUncovered: {
      starter: '0.0400', base: '0.0300', plus: '0.0200', pro: '0.0100', enterprise: 'custom',
    },
    processingFee: {
      starter: '0.0300', base: '0.0300', plus: '0.0300', pro: '0.0300', enterprise: 'custom',
    },
    platformFixedFee: {
      starter: 0, base: 0, plus: 0, pro: 0, enterprise: null,
    },
    processingFixedFee: {
      starter: 0, base: 0, plus: 0, pro: 0, enterprise: null,
    },
  },
  subscriptionPrices: {
    monthlyUsd: {
      starter: 0, base: 3500, plus: 11500, pro: 39500, enterprise: null,
    },
    yearlyMonthlyUsd: {
      starter: 0, base: 2900, plus: 9500, pro: 29500, enterprise: null,
    },
  },
  trialDays: {
    starter: 0, base: 14, plus: 14, pro: 0, enterprise: 0,
  },
  marketingFeatureKeys: new Set(["email_builder","broadcasts_email","broadcasts_sms","segments","email_templates","marketing_automation_journeys","custom_email_domain","ai_content_generation","social_media_scheduling","text_to_give_two_way_sms","direct_mail_acknowledgement_letters"]),
  allLiveFeatureKeys: new Set(["fundraiser_form","event_form","hosted_pages","donor_portal","virtual_terminal","subscriptions","checkout_bump","fee_coverage","monthly_bump_upsell","scheduled_donations","multifund_promo_dedications_custom_inputs","refunds_disputes_payouts","basic_donate_button_form_embed","fundraising_bar","qr_codes","supporter_lists","fundraising_flag","add_to_cart","overlay_popup","prefilled_links","contact_portal_element","contacts_import_export_tags","contact_merging","email_builder","broadcasts_email","broadcasts_sms","segments","email_templates","marketing_automation_journeys","custom_email_domain","analytics_dashboard_ai_assistant","post_donation_conversion_tracking","public_api_webhooks_zapier","double_the_donation","crm_integrations","rbac","per_donation_tax_receipts","eoy_bulk_tax_receipts","support_docs","email_support","chat_support","dedicated_csm_sla"]),
  overrideFeeModes: {"legacy_custom":"negotiated"},
};
